import { initMixpanelEvents } from "jiffy-analytics";
import "./ui";
import { initDelivery, initReviews, initGallery, initNavigation } from "./sections";
import "./jiffymade-landing.scss";

document.addEventListener("DOMContentLoaded", () => {
  initDelivery();
  initNavigation();
  initGallery();
  initReviews();

  initMixpanelEvents(".jiffymade-landing");
});
